export const DesignRequestStatus = {
  Open: 'open',
  InProgress: 'in_progress',
  Completed: 'completed',
  Cancelled: 'cancelled',
} as const;
export type DesignRequestStatus = (typeof DesignRequestStatus)[keyof typeof DesignRequestStatus];

export const ALL_DESIGN_REQUEST_STATUSES: readonly DesignRequestStatus[] = [
  DesignRequestStatus.Open,
  DesignRequestStatus.InProgress,
  DesignRequestStatus.Completed,
  DesignRequestStatus.Cancelled,
];

export const DESIGN_REQUEST_STATUS_LABELS: Readonly<Record<DesignRequestStatus, string>> = {
  [DesignRequestStatus.Open]: 'Open',
  [DesignRequestStatus.InProgress]: 'In progress',
  [DesignRequestStatus.Completed]: 'Completed',
  [DesignRequestStatus.Cancelled]: 'Cancelled',
};

export interface DesignRequest {
  readonly id: string;
  readonly orderId: string;
  readonly caseId: string | null;
  readonly status: DesignRequestStatus;
  readonly designProvider: string | null;
  readonly requestedDate: string | null;
  readonly completedDate: string | null;
  readonly notes: string | null;
}
